import ApiService from './api'
import {TokenService} from './token'
import qs from 'qs';

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode
  }
}

const UserService = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns access_token
   * @throws AuthenticationError
   **/
  login: async function (username, password) {
    const data = {
      grant_type: 'password',
      scope: 'openid',
      code: 'code',
      username,
      password,
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
    };

    try {
      const response = await ApiService.post(process.env.VUE_APP_ROOT_API_AUTH, qs.stringify(data));
      if (response.data.access_token) {
        TokenService.saveToken(response.data.access_token);
        TokenService.saveRefreshToken(response.data.refresh_token);
        ApiService.setHeader();
        TokenService.saveUser(username);
        ApiService.mount401Interceptor();
        return response.data.access_token
      } else {
        throw {
          response: {
            status: 'invalid credentials',
            data: {
              detail: 'Please check if the provided login-credentials are correct.'
            }
          }
        };
      }
    } catch (error) {
      throw new AuthenticationError(error.response.status, error.response.data.detail)
    }

  },
  /**
   * Refresh the access token.
   **/
  refreshToken: async function () {
    const refreshToken = TokenService.getRefreshToken();
    const data = {
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET
    };

    try {
      const response = await ApiService.post(process.env.VUE_APP_ROOT_API_AUTH, qs.stringify(data));

      TokenService.saveToken(response.data.access_token);
      TokenService.saveRefreshToken(response.data.refresh_token);
      ApiService.setHeader();

      return response.data.access_token;
    } catch (error) {
      console.warn('refresh token kapot', error);
      throw new AuthenticationError(error.response.status, error.response.data.detail);
    }

  },

  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.removeToken();
    TokenService.removeRefreshToken();
    TokenService.removeUser();
    ApiService.removeHeader();
    ApiService.unmount401Interceptor();
  },

  getUserData: async function () {
    const username = TokenService.getUser();
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/userdata?username=${username}`;
    try {
      const response = await ApiService.get(query);
      if (response.status) {
        console.log(response.data.data);
        return response.data;
      }
      return false;
    } catch (error) {
      console.warn('!! error fetching userData ', error);
    }
  },
};

export default UserService

export {UserService, AuthenticationError}
